import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useUserStore from "../../utils/storeApp";
import CallAPI from "../../services/apiCalls";
import $ from "jquery";

const OrgCsrModal = () => {
    const navigate = useNavigate();
    const { userToken, sharedObject, setXDRArr, SetSharedObject } = useUserStore(
        (state) => ({
            userToken: state.userToken,
            sharedObject: state.sharedObject,
            SetSharedObject: state.SetSharedObject,
        })
    );
    const [answers, setAnswers] = useState(null);
    const [processing, SetProcessing] = useState(false);
    const [errCreateMsg, SetErrCreateMsg] = useState(false);
    const [msg, SetMsg] = useState(false);
    const setAnswer = async (questionId, answer, questtwo) => {
        if (questionId === "uploadCSR") {
            await setAnswers({
                ...answers,
                [questionId]: answer,
                postCSR: false,
                orgCSRText: "",
            });
        } else if (questionId === "postCSR") {
            await setAnswers({
                ...answers,
                [questionId]: answer,
                uploadCSR: false,
            });
            $("#exampleFormControlFile1").val("");
        } else {
            await setAnswers({
                ...answers,
                [questionId]: answer,
            });
        }
    };
    useEffect(() => {
        if (sharedObject.CSRUploadPage !== "fake") SetErrCreateMsg(false);
        setAnswers(sharedObject.orgActionObj);
    }, [sharedObject.orgActionObj, sharedObject.CSRUploadFlag]);

    const UpdateCSR = async () => {
        SetErrCreateMsg(false);
        SetProcessing(true);
        const formData = new FormData();
        const fileField = document.querySelector('input[type="file"]');
        formData.append("Files", fileField.files[0]);
        if ((fileField.files[0] && answers?.uploadCSR === true) || answers?.postCSR === true) {
            let call =
                "/organization/PostRequest?orgId=" +
                answers.id +
                "&csrText=" +
                answers.orgCSRText;
            const res = await CallAPI(call, formData, "post", userToken, true);
            await SetSharedObject("ResponseCode", res.code);
            if (res.status === "SUCCESS") {
                SetProcessing(false);
                $("#orgCSRModal").modal("hide");
                let det = { ...sharedObject.orgActionObj, isCsrOrg: true };
                SetSharedObject("orgActionObj", det);
                if (sharedObject.CSRUploadPage === "Enable")
                    SetSharedObject("CSRUploadFlag", true);
            } else if (res.status === "SERVERERROR") {
                SetProcessing(false);
                if (sharedObject.CSRUploadPage === "Enable") {
                    SetSharedObject("CSRUploadPage", "fake");
                    SetSharedObject("CSRUploadFlag", false);
                }

                SetProcessing(false);
                let msg = res.data;
                if (Object.keys(msg).length > 0 && msg.constructor === Object) {
                    let str = "<ul>";
                    for (let el in msg) {
                        str += `<li>${el}</li>`;
                    }
                    str += "</ul>";
                    SetMsg(str);
                } else {
                    SetMsg(msg);
                }

                SetErrCreateMsg(true);
                SetProcessing(false);
            }
        } else {
            if (answers?.uploadCSR === true) {
                let msg = "Please include a CSR file";
                SetMsg(msg);
                SetErrCreateMsg(true);
                SetProcessing(false);
            } else if ((answers?.postCSR === false && answers?.uploadCSR === false) || (!answers?.postCSR && !answers?.uploadCSR)) {
                let msg = "Please select an option";
                SetMsg(msg);
                SetErrCreateMsg(true);
                SetProcessing(false);
            }
        }
    };
    return (
        <div className="OrgCsrModal">
            <div
                className="modal fade"
                id="orgCSRModal"
                data-backdrop="false"
                data-keyboard="false"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="myModalLabel"
                aria-hidden="false"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title" id="myModalLabel">
                                {" "}
                                Upload or Post CSR{" "}
                            </div>
                            <button
                                type="button"
                                className="close"
                                //data-dismiss="modal"
                                aria-label="Close"
                                onClick={(el) => {
                                    SetSharedObject("CSRUploadFlag", sharedObject.CSRUploadFlag);
                                    SetErrCreateMsg(false);
                                    $("#orgCSRModal").modal("hide");
                                }}
                            >
                                {" "}
                                <span aria-hidden="false">&times;</span>{" "}
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="descript2-container">
                                The CSR (Certificate Signing Request) request below must match
                                the following values for CN, O, and OU in the Subject Name
                                otherwise the request will be rejected.
                            </div>
                            <div className="csr-values">
                                <label>CN</label> = {answers?.organizationName}
                                <br />
                                <label>O</label> = {answers?.id}
                                <br />
                                <label>OU</label> = {answers?.vendorId}
                            </div>
                            <div className="descript2-container">
                                {" "}
                                When you provide new CSR your existing certificate (if any) will
                                be revoked and replaced with the new one.{" "}
                            </div>
                            <div className="upload-csr">
                                <input
                                    type="checkbox"
                                    className="form-control sp-margin5"
                                    id="uploadCSR"
                                    name="uploadCSR"
                                    checked={answers?.uploadCSR}
                                    value={answers?.uploadCSR}
                                    onChange={(el) => {
                                        setAnswer("uploadCSR", el.target.checked);
                                    }}
                                />
                                <label>Upload CSR</label>
                                <div className="form-group" hidden={!answers?.uploadCSR}>
                                    <input
                                        type="file"
                                        className="form-control-file cblu-clr "
                                        id="exampleFormControlFile1"
                                        onClick={(el) => {
                                            SetMsg(false);
                                            SetErrCreateMsg(false);
                                        }}
                                    />
                                </div>
                                <div>
                                    <input
                                        type="checkbox"
                                        className="form-control sp-margin5"
                                        id="postCSR"
                                        name="postCSR"
                                        checked={answers?.postCSR}
                                        value={answers?.postCSR}
                                        onChange={(el) => {
                                            setAnswer("postCSR", el.target.checked);
                                            SetMsg(false);
                                            SetErrCreateMsg(false);
                                        }}
                                    />
                                    <label>Post CSR</label>
                                    <textarea
                                        id="orgCSRText"
                                        name="orgCSRText"
                                        className="form-control"
                                        hidden={!answers?.postCSR}
                                        value={answers?.orgCSRText}
                                        onChange={(el) => {
                                            setAnswer("orgCSRText", el.target.value);
                                        }}
                                    ></textarea>
                                </div>
                                {errCreateMsg ? (
                                    <div className={`alert alert-danger`}>{msg}</div>
                                ) : null}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={(e) => UpdateCSR()}
                            >
                                Submit{" "}
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={(el) => {
                                    SetSharedObject("CSRUploadFlag", sharedObject.CSRUploadFlag);
                                    SetErrCreateMsg(false);
                                    $("#orgCSRModal").modal("hide");
                                }}
                                data-dismiss="modal"
                            >
                                {" "}
                                Cancel{" "}
                            </button>
                        </div>
                    </div>
                </div>
                {processing ? <div className="loading"></div> : null}
            </div>
        </div>
    );
};

export default OrgCsrModal;
